import { render, staticRenderFns } from "./PageTransition.vue?vue&type=template&id=6760d024"
import script from "./PageTransition.vue?vue&type=script&lang=js"
export * from "./PageTransition.vue?vue&type=script&lang=js"
import style0 from "./PageTransition.vue?vue&type=style&index=0&id=6760d024&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports